import angular from 'angular';

export default class MapManager {
    constructor(NgMap, $window, $q, $timeout) {
        this.ngMap = NgMap;
        this.$window = $window;
        this.$q = $q;
        this.$timeout = $timeout;

        this.ngMap.getMap().then((map) => {
            this.map = map;
            this.setupResize();
        });

        this.map = null;
        this.markerClusterer = null;
        this.resizingPromise = null;
    }

    setupResize() {
        google.maps.event.addDomListener(this.$window, 'resize', () => {
            if (this.resizingPromise === null) {
                this.resizingPromise = this.$timeout(() => {
                    var center = this.map.getCenter();
                    google.maps.event.trigger(this.map, 'resize');
                    this.map.setCenter(center);
                    this.resizingPromise = null;
                }, 2);
            }
        });
    }

    updateCluster() {
        return this.$q((resolve, reject) => {
            this.ngMap.getMap().then((map) => {
                this.map = map;
                this.doUpdateCluster();
                resolve();
            });
        });
    };

    doUpdateCluster() {
        if (this.markerClusterer !== null) {
            this.markerClusterer.clearMarkers();
        }

        var locationMarkers = [];
        angular.forEach(this.map.markers, (marker) => {
            locationMarkers.push(marker);
        });

        this.markerClusterer = new MarkerClusterer(this.map, locationMarkers, {
            // imagePath: webpack_env.publicPath + 'm',
            imagePath: 'https://github.com/googlemaps/js-marker-clusterer/raw/gh-pages/images/m',
            maxZoom: 17,
            gridSize: 50
        });
    }

    showInfoWindow(markerIdentifier) {
        this.map.showInfoWindow('default', markerIdentifier);
    }
}

MapManager.$inject = ['NgMap', '$window', '$q', '$timeout'];
